<template>
    <div class="j-order-and-wishlist" :style="product.active ? '': 'display: none;'">
        <form :id="`form-${product.id}`">
            <input type="hidden" name="csrf-token" :value="csrfToken">
            <input type="hidden" name="article_reference" id="article-reference"
                   :value="product.id"/>

            <button class="dx_button dx_button-cta j-btn-cart btn-add-to-cart rs-add-to-cart" data-eventtype="add_to_cart_product-page" :data-object="product.data_object" :data-id="product.id" :data-name="product.name">
                <div class="dx_spinner"></div>
                <div v-html="icons.bag"></div>
                <span>{{ translations['buttons.1'] }}</span>
            </button>

        </form>

        <div :class="`c-stock ${product.has_stock ? 'c-instock' : 'c-outstock'} c-stock-new`"
             id="delivery-time-big-container">
            <span v-for="(string, i) in product.delivery_text_array" v-bind:key="i">{{ string }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderAndWishlist',
    computed: {
        usps() {
            return this.$store.getters.usps
        },
        translations() {
            return this.$store.getters.trans
        },
        icons() {
            return this.$store.getters.icons
        },
        product() {
            return this.$store.getters.activeProduct
        },
        csrfToken() {
            return document.querySelector('#dx_product-page').dataset.csrf;
        }
    }
}
</script>
